import { createContext, useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import API from "./API";
import GoogleAnaltics from "./Component/Analytics/GoogleAnalytics";
import GoogleCustomeSetting from "./Component/Analytics/GoogleCustomeSetting";
import GoogleRealTime from "./Component/Analytics/GoogleReatTime";
import ErrorPage from "./Component/Main/ErrorPage";
import { decryptData } from "./controllers/encryptionUtils";
import { clientData, GetClient } from "./controllers/GetClient";
import { LastRouteProvider } from "./controllers/LastRouteContext";
import SaveChangesPopup from "./controllers/SaveChangesPopup";
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import 'react-datepicker/dist/react-datepicker.css';

export const ChangePathContext = createContext();
export const PlanPermission = createContext();
export const DataLoad = createContext();
export const SelectSection = createContext();
export const Extention = createContext();
export const StoreDeletePending = createContext();

const App = () => {
  let token = localStorage.getItem("token");
  const clientInfo = clientData;
  const [installedExtensions, setInstalledExtensions] = useState([]);
  const [planActive, setPlanActive] = useState(false);
  const [isIncluded, setIsIncluded] = useState(true);
  const [spinner, setSpinner] = useState(token && !isIncluded ? true : false);
  const [Permissions, setPermissions] = useState();
  const [announcement, setAnnouncement] = useState(false);
  const [isNotification, setIsNotification] = useState(false);
  const [notificationMsg, setNotificationMsg] = useState("");
  const [severity, setSeverity] = useState();
  const [AnnData, setAnnData] = useState();
  const [accessDenied, setAccessDenied] = useState(false);
  const [tokenReady, setTokenReady] = useState(!!localStorage.getItem("token"));

  let business_name = localStorage.getItem("business_name");
  const navigate = useNavigate();

  const installExtentionName =
    installedExtensions?.length > 0 ? installedExtensions?.map((x) => x?.super_extension_id) : [];

  const subscrptionLine =
    (planActive && clientInfo?.billing_detail?.next_billing_date && token && !isIncluded) ||
    (planActive && clientInfo?.billing_detail?.plan_type === "Free" && !isIncluded);
  const [saveChanges, setSaveChanges] = useState({
    isUnsaveChanges: false,
    showChangesPopup: false,
    backLink: "",
    title: "",
  });
  const [planPermission, setPlanPermission] = useState({
    isPlanPermissions: true,
    forModule: null,
  });
  const [dataLoading, setDataLoading] = useState(false);
  const GetInstalledExtensions = async () => {
    try {
      const ApiCall = await API.get(`/admin/extension/GetInstalledExtensions`);
      if (ApiCall.data) {
        const result = decryptData(ApiCall?.data);
        setInstalledExtensions(result?.data);
        return result?.data;
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const GetUserPermissions = async () => {
    try {
      let ApiCall = await API.get("/admin/role/getLoginUserRole");
      const result = decryptData(ApiCall?.data);
      setPermissions(result);
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const GetAnnouncemnet = async () => {
    try {
      let ApiCall = await API.get(`/admin/announcement/UserGetAnnouncements?type=1&limit=3&page=1`);
      if (ApiCall?.data) {
        const result = decryptData(ApiCall?.data);
        setAnnouncement(true);
        setAnnData(result);
      } else {
        setAnnouncement(false);
      }
    } catch (error) {
      setIsNotification(true);
      setNotificationMsg(error);
      setSeverity("error");
    }
  };

  const CheckPlanStatus = async () => {
    if (business_name?.length > 0) {
      setSpinner(true);
      try {
        await API.get(`/admin/plan/planStatusCheck`);
        setPlanActive(true);
        await GetInstalledExtensions();
        await GetUserPermissions();
        await GetAnnouncemnet();
      } catch (error) {
        if (error?.response?.status === 498) {
          setPlanActive(false);
        } else {
          setIsNotification(true);
          setNotificationMsg(error);
          setSeverity("error");
        }
      } finally {
        setSpinner(false);
      }
    } else {
      setPlanActive(false);
    }
  };

  useEffect(() => {
    const savedDarkMode = localStorage.getItem("dark-mode");
    if (savedDarkMode === "true" || savedDarkMode === true) {
      document.documentElement.classList.add("dark-mode");
    } else {
      document.documentElement.classList.remove("dark-mode");
    }

    if (window.self === window.top) {
      setAccessDenied(true);
      return;
    }
    if (!document.referrer || !document.referrer.startsWith(process.env.REACT_APP_ADMIN_URL)) {
      setAccessDenied(true);
      return;
    }
    window.addEventListener("message", (event) => {
      if (event.origin === process.env.REACT_APP_ADMIN_URL) {
        const data = event.data;
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            localStorage.setItem(key, data[key]);
          }
        }
        if (data.token) {
          setTokenReady(true);
        }
        if (data?.type === "NAVIGATE_IFRAME_INTERNAL" && typeof data.path === "string") {
          navigate(data.path);
        }

        if (data?.type === "DARK_MODE_CHANGE" || data?.type === "INIT_IFRAME") {
          const isDarkMode =
            data?.type === "DARK_MODE_CHANGE"
              ? data["dark-mode"]
              : data["dark-mode"] === "true" || data["dark-mode"] === true;
          console.log(isDarkMode, "isDarkMode");
          localStorage.setItem("dark-mode", isDarkMode);
          if (isDarkMode) {
            document.documentElement.classList.add("dark-mode");
          } else {
            document.documentElement.classList.remove("dark-mode");
          }
        }
      } else {
        console.warn("Message origin not trusted:", event.origin);
      }
    });
    // GetInstalledExtensions();
    // CheckPlanStatus();
    // GetClient();
    // if (searchPath?.pathname === "/") {
    //   navigate("/product-subscription");
    // }
  }, []);
  useEffect(() => {
    if (!tokenReady) return;

    // These functions require token to be available
    GetInstalledExtensions();
    CheckPlanStatus();
    GetClient();
  }, [tokenReady]);
  return (
    <>
      <LastRouteProvider>
        <ChangePathContext.Provider value={{ saveChanges, setSaveChanges }}>
          <PlanPermission.Provider value={{ planPermission, setPlanPermission }}>
            <DataLoad.Provider value={{ dataLoading, setDataLoading }}>
              <SaveChangesPopup />

              {/* Product Subscription */}
              <Routes>
                {/* Chat */}
                {installExtentionName?.length > 0 &&
                  installExtentionName?.includes(`6683ecf2529fd09fc74be683`) && (
                    <>
                      <Route path="/google-analytics/realtime" element={planActive && <GoogleRealTime />} />
                      <Route
                        path="/google-analytics/snapshot-report"
                        element={planActive && <GoogleAnaltics />}
                      />
                      <Route
                        path="/google-analytics/settings"
                        element={
                          planActive && (
                            <GoogleCustomeSetting installedExtensions={installedExtensions} />
                          )
                        }
                      />
                    </>
                  )}
                <Route path="/*" element={planActive || (accessDenied && <ErrorPage />)} />
              </Routes>
            </DataLoad.Provider>
          </PlanPermission.Provider>
        </ChangePathContext.Provider>
      </LastRouteProvider>
    </>
  );
};

export default App;
